import React, { FC, useEffect, useState } from "react";
import { API_URL } from "../../../../actions/settings";
import { IonRow } from "@ionic/react";
import BoxPlot from "../../../extras/BoxPlot";
import AnnualEnergyTargetSimilarBuildingList from "./AnnualEnergyTargetSimilarBuildingList";

async function getSuggestions(token: string, id: any) {
  return fetch(`${API_URL}/benchmark/suggested_rates/${id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
  }).then((res) => {
    return res.json();
  });
}

interface IProps {
    id : string | null | undefined;
};

interface Suggestion {
    "buildings": SimilarBuilding[],    
    "kwh_rates": number[],
    "therm_rates": number[]
}

type SimilarBuilding = {
    building_id: string;
    building_name: string;
    kwh_per_sqft: string | number;
    therms_per_sqft: string | number;
};

const defaultSuggestion = {
    "buildings": [],    
    "kwh_rates": [],
    "therm_rates": []
}

const AnnualEnergyTargetSuggestions:FC<IProps> = (props) => {
    const { id } = props;
    const [ suggestions, setSuggestions ] = useState<Suggestion>(defaultSuggestion);    
    const [openTable, setOpenTable] = useState<boolean>(false);


    useEffect(() => {
        const fetchSuggestions = async () => {
            const token = `Token ${(localStorage.getItem("token") || "").slice(1, -1)}`;
            const res = await getSuggestions(token, id);            
            if (res.status !== "error") {
                setSuggestions(res.data);
            }
        };

        fetchSuggestions();
    }, [id]);

    
    return<div style={{border:'3px solid #444', 
            backgroundColor:'#444', 
            padding:'1rem', 
            margin:'1rem 0',
            borderRadius:'8px'}}>
            <div style={{textAlign:'center', marginBottom:'0.5rem', fontSize:'1.2rem', fontWeight:'bold'}}>
                Similar AI Buildings
            </div>
            <div>
                <div className="pointer" style={{fontSize:'12px',textAlign:'center', marginTop:'0rem',width:'100%',textDecoration:'underline'}} onClick={()=>setOpenTable(!openTable)}>{openTable?'Hide Buildings':'View Buildings'}</div>     
            </div>
            <IonRow >
                <div style={{textAlign:'center', marginTop:'1rem',width:'100%'}}>kWh/ft<sup>2</sup> Distribution</div>                
                <BoxPlot data={suggestions.kwh_rates} useContainerWidth={true}/>                
                
                <div style={{textAlign:'center', marginTop:'1rem',width:'100%'}}>Therms/ft<sup>2</sup> Distribution</div>                
                <BoxPlot data={suggestions.therm_rates} useContainerWidth={true}/>
                <AnnualEnergyTargetSimilarBuildingList data={suggestions.buildings} open={openTable}/>
            
        </IonRow>
        </div>
};

export default AnnualEnergyTargetSuggestions;